import { NgModule } from '@angular/core';
import { BpSpinnerComponent } from './spinner.component';

@NgModule({
  declarations: [
    BpSpinnerComponent
  ],
  exports: [
    BpSpinnerComponent
  ]
})
export class BpSpinnerModule { }
